import { IconProps } from '../types';

function MeasuringTapeAltSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        fillRule="evenodd"
        d="M17,10c-.55,0-1,.45-1,1v1h-2v-4c0-3.31-2.69-6-6-6s-6,2.69-6,6,2.69,6,6,6h5c.55,0,1-.45,1-1h2c0,.55.45,1,1,1s1-.45,1-1v-2c0-.55-.45-1-1-1ZM8,10c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2ZM17,15h1v3H2v-3h1v2h2v-2h1v2h2v-2h1v2h2v-2h1v2h2v-2h1v2h2v-2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default MeasuringTapeAltSolidIcon;
